module.exports = __webpack_public_path__ + "static/media/ic_copy_message.b539feda.svg";